var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-form flex col-4" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c("el-input", {
              staticClass: "width-1-5x bottom-line",
              attrs: { disabled: "", type: "text" },
              model: {
                value: _vm.transVoucherInfo.innerNo,
                callback: function($$v) {
                  _vm.$set(_vm.transVoucherInfo, "innerNo", $$v)
                },
                expression: "transVoucherInfo.innerNo"
              }
            }),
            _vm._v(" "),
            _vm.selectVoucher
              ? _c("div", {
                  staticClass:
                    "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                  attrs: { title: "选择" },
                  on: { click: _vm.selectTransVoucherInfoDlg }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.transVoucherInfo.srcVoucherType != null
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.transVoucherInfo.srcVoucherInnerNo))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.memo || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.totalQuantity))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                parseFloat(_vm.transVoucherInfo.totalNetWorth || 0).toFixed(2)
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.srcComFullName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.transVoucherInfo.srcBizUnitCode || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.transVoucherInfo.srcCostCenterCode || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.transVoucherInfo.srcPrftCenterCode || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(9),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.dstComFullName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(10),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.transVoucherInfo.dstBizUnitCode || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(11),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.transVoucherInfo.dstCostCenterCode || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(12),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.transVoucherInfo.dstPrftCenterCode || "无"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _vm._m(13),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.createTime || "无"))])
        ])
      ]),
      _vm._v(" "),
      _vm.principalId != null && !_vm.transVoucherInfo.crossFlag
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(14),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.autoReceive,
                      callback: function($$v) {
                        _vm.autoReceive = $$v
                      },
                      expression: "autoReceive"
                    }
                  },
                  [_vm._v("机构负责人自动领用")]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.splittedReceipt
      ? _c("div", { staticClass: "simple-row" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.selectDevice()
                    }
                  }
                },
                [_vm._v("选择调拨项")]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            ref: "multipleTable",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.deviceItemList,
              maxHeight: "500",
              border: "",
              "tooltip-effect": "dark"
            }
          },
          [
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "innerCode",
                "min-width": "250",
                label: "资产编号",
                fixed: "",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "assetType",
                width: "100",
                label: "管理方式",
                align: "center",
                fixed: ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm.assetTypeMap[rows.row.assetType]))
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "title",
                label: "资产描述全称",
                width: "200",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "fixedSpec",
                label: "规格",
                width: "150",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "transQuantity",
                label: "调拨数量",
                width: "80",
                align: "right"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "directQuantity",
                width: "100",
                label: "已退还数量"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "receiptQuantity",
                width: "100",
                label: "已验收数量"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "quantity",
                label: "验收数量",
                width: "80"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.assetType == _vm.commonDevcVal ||
                      !scope.row.splitFlag
                        ? _c("span", [_vm._v(_vm._s(scope.row.quantity))])
                        : _c("el-input", {
                            staticClass: "input-content-right",
                            attrs: {
                              type: "number",
                              disabled: scope.row.splitible,
                              min: "0"
                            },
                            on: {
                              change: function($event) {
                                _vm.transAvQuantityChange(scope)
                              }
                            },
                            model: {
                              value: scope.row.quantity,
                              callback: function($$v) {
                                _vm.$set(scope.row, "quantity", _vm._n($$v))
                              },
                              expression: "scope.row.quantity"
                            }
                          })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "theUnit",
                label: "单位",
                width: "60"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "orgWorth",
                width: "80",
                label: "原值(元)"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.orgWorth != null
                        ? _c("span", [
                            _vm._v(_vm._s(rows.row.orgWorth.toFixed(2)))
                          ])
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "netWorth",
                width: "80",
                label: "净值(元)"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.netWorth != null
                        ? _c("span", [
                            _vm._v(_vm._s(rows.row.netWorth.toFixed(2)))
                          ])
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "aggtDeprWorth",
                width: "80",
                label: "累计折旧(元)"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.aggtDeprWorth != null
                        ? _c("span", [
                            _vm._v(_vm._s(rows.row.aggtDeprWorth.toFixed(2)))
                          ])
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "",
                label: "调入部门全称",
                width: "200",
                "show-overflow-tooltip": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.dstComFullName != null
                        ? _c("span", { attrs: { align: "left" } }, [
                            _vm._v(_vm._s(scope.row.dstComFullName))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orgType == 1
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              attrs: { align: "right" },
                              on: {
                                click: function($event) {
                                  _vm.selectDstComName(scope.$index, false)
                                }
                              }
                            },
                            [_vm._v("选择部门")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _vm.showBizUnitWarehouse
              ? _c("el-table-column", {
                  attrs: {
                    prop: "dstWarehouseName",
                    label: "调入仓库",
                    width: "140",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: {
                                change: function($event) {
                                  _vm.selectDstWarehouse(scope.$index, false)
                                }
                              },
                              model: {
                                value: scope.row.dstWarehouseId,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "dstWarehouseId", $$v)
                                },
                                expression: "scope.row.dstWarehouseId"
                              }
                            },
                            _vm._l(_vm.wareHouseInList, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id }
                              })
                            })
                          )
                        ]
                      }
                    }
                  ])
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "dstComNo",
                label: "调入机构编号",
                width: "120",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "dstCostCenterCode",
                label: "调入成本中心",
                width: "160",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "srcComFullName",
                label: "调出部门全称",
                width: "140",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "srcRealComCode",
                label: "调出公司编码",
                width: "160",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "srcCostCenterCode",
                label: "调出成本中心",
                width: "160",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _vm.normalFlag
              ? _c("el-table-column", {
                  attrs: {
                    prop: "taxRate",
                    label: "税率(%)",
                    width: "140",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.row.taxRate))])]
                      }
                    }
                  ])
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "ntxPrice",
                label: "未税价(元)",
                width: "140",
                align: "right"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.dealingFlag
                        ? _c(
                            "span",
                            [
                              _c("el-input", {
                                staticClass: "width-2x",
                                attrs: { type: "number" },
                                on: { blur: _vm.changeNtxPrice },
                                model: {
                                  value: scope.row.ntxPrice,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "ntxPrice", $$v)
                                  },
                                  expression: "scope.row.ntxPrice"
                                }
                              })
                            ],
                            1
                          )
                        : _c("span", [_vm._v(_vm._s(scope.row.ntxPrice))])
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调拨单号：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("来源单据号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调拨总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调拨总金额")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调出机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调出机构编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调出成本中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调出利润中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调入机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调入机构编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调入成本中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调入利润中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调拨日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [_c("label")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-586c6b0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-586c6b0f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/transVoucher/ShopDeviceTransVoucherReceiptSave.vue
// module id = 2533
// module chunks = 0